import { Box } from "@mui/material";

import { useIsMobile } from "hooks/useIsMobile";

import type { PropsWithChildren } from "react";

export function PageLayout(props: PropsWithChildren) {
  const { children } = props;
  const bigScreen = !useIsMobile({ maxWidth: 1200 });

  return (
    <Box
      id="page-layout"
      sx={{
        backgroundColor: "#fefefe",
        flex: 1,
        padding: bigScreen ? "2rem" : ".5rem",
      }}
    >
      {children}
    </Box>
  );
}
